<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1>All Holidays</h1>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Latest Entries
            <v-spacer />
            <v-text-field v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          @input="page = 1" />
          </v-card-title>
          <v-data-table class="elevation-1"
                        sort-by="Date"
                        :disable-pagination="items.length < 10"
                        :hide-default-footer="items.length < 10"
                        :loading="loading"
                        :headers="headers"
                        :items="items"
                        :footer-props="{
                          itemsPerPageOptions: [],
                          showFirstLastPage: true,
                        }"
                        :search="search"
                        :page.sync="page">
            <template v-slot:item.Date="{ item }">
              {{ friendlyDate(item.Date) }}
            </template>
            <template v-slot:item.Actions="{ item }">
              <v-tooltip top :activator="`#editBtn-${item.Id}`">
                Edit
              </v-tooltip>
              <v-tooltip top :activator="`#deleteBtn-${item.Id}`">
                Delete
              </v-tooltip>
              <v-btn icon link
                     color="accent"
                     :id="`editBtn-${item.Id}`"
                     :to="{ name: 'day.update', params: { id: item.Id } }">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn icon link
                     color="accent"
                     v-if="$store.getters.can('Admin')"
                     :id="`deleteBtn-${item.Id}`"
                     @click="$refs.confirm.open(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" dark link :to="{ name: 'day.create' }">
          <v-icon dark left>add</v-icon>
          Create
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <ConfirmDialog ref="confirm"
                     title="WARNING"
                     width="450"
                     @continue="deleteItem($event)">
        This action will permanently delete this holiday
        and remove all references from Offices or Locations that may use it.<br><br>
        <strong>Are you sure you would like to proceed?</strong>
      </ConfirmDialog>
    </v-row>
  </v-container>
</template>

<script>
import { friendlyDate } from '@/components/Mixins/FriendlyFields';

export default {
  name: 'DayIndex',
  data() {
    return {
      headers: [
        { text: 'Title', value: 'Title' },
        { text: 'Date', value: 'Date' },
        {
          text: 'Actions',
          value: 'Actions',
          sortable: false,
          filterable: false,
        },
      ],
      items: [],
      loading: true,
      search: '',
      page: 1,
    };
  },
  methods: {
    friendlyDate,
    async deleteItem(item) {
      try {
        const i = this.items.indexOf(item);
        await this.$store.dispatch('delete', `Day/${item.Id}`);
        this.items.splice(i, 1);
      } catch (e) {
        // Do nothing
      }
    },
  },
  async created() {
    const response = await this.$store.dispatch('get', 'Day');
    this.items = response.data;
    this.loading = false;
  },
};
</script>
